// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2RWvv","gfeWrapper":"CalendarEvent_gfeWrapper__M0WzR"};